import { toast } from "react-toastify";
import { TimeAutocomplete } from "./TimeAutocomplete";

interface Props {
  hour: string;
  setHour: (newHour: string) => void;
}

const hourList = Array.from({ length: 12 }, (_, index) =>
  (index + 1).toString()
);

const candidateMap: { [key: string]: string } = {};
hourList.forEach((time) => {
  candidateMap[time] = time;
});

export const SearchHour: React.FC<Props> = ({ hour, setHour }) => {
  const handleChangeTextField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.value !== "") {
      const newTime = Number(event.target.value);

      if (isNaN(newTime)) {
        toast.error("숫자만 입력 가능합니다.");
        setHour("");
        return;
      } else if (newTime < 1 || newTime > 12) {
        toast.error("1 ~ 12 사이의 숫자만 입력 가능합니다.");
        setHour("");
        return;
      }
    }
    setHour(event.target.value);
  };

  return (
    <TimeAutocomplete
      width="84px"
      placeholder="00"
      value={hour}
      candidateMap={candidateMap}
      onClickSelectItem={(key: string) => setHour(key)}
      onChangeTextField={handleChangeTextField}
      isActive={hour !== ""}
    />
  );
};
